import { useTranslation } from 'next-i18next';
import styled from 'styled-components';

import { TEMPLATE_FILES, TemplateType } from '@/features/interwill';

import { Banner } from './Banner';
import { Document } from './Document';

export const Materials = () => {
  const { t } = useTranslation('pages/pageInterwill', { keyPrefix: 'materials.demo' });

  return (
    <Container>
      <Banner />
      <Documents>
        <Document
          file={TEMPLATE_FILES[TemplateType.DEMO_WILL]}
          title={t('lastWillOfYan')}
          image="/assets/pages/interwill/lastWillOfYan.svg"
        />
        <Document
          file={TEMPLATE_FILES[TemplateType.TESTATOR_ATTESTATION]}
          title={t('testatorAttestation')}
          image="/assets/pages/interwill/testatorsAttestation.svg"
        />
        <Document
          file={TEMPLATE_FILES[TemplateType.WILL_CERTIFICATE]}
          title={t('willCertificate')}
          image="/assets/pages/interwill/willCertificate.svg"
        />
      </Documents>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  gap: 40px;

  @container (width < 922px) {
    flex-direction: column;
    gap: 24px;
  }
`;

const Documents = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 24px;

  @container (width < 922px) {
    flex-direction: column;
  }
`;
